import { render, staticRenderFns } from "./recommended-listing-modal.vue?vue&type=template&id=b24f609a&scoped=true"
import script from "./recommended-listing-modal.vue?vue&type=script&lang=js"
export * from "./recommended-listing-modal.vue?vue&type=script&lang=js"
import style0 from "./recommended-listing-modal.vue?vue&type=style&index=0&id=b24f609a&prod&lang=scss&scoped=true"
import style1 from "./recommended-listing-modal.vue?vue&type=style&index=1&id=b24f609a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24f609a",
  null
  
)

export default component.exports